import { render, staticRenderFns } from "./d3534747-4c81-4341-ac04-7e0fc294d453.vue?vue&type=template&id=8c04afb4&scoped=true"
import script from "./d3534747-4c81-4341-ac04-7e0fc294d453.vue?vue&type=script&lang=ts"
export * from "./d3534747-4c81-4341-ac04-7e0fc294d453.vue?vue&type=script&lang=ts"
import style0 from "./d3534747-4c81-4341-ac04-7e0fc294d453.vue?vue&type=style&index=0&id=8c04afb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c04afb4",
  null
  
)

export default component.exports